import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import adminStore from "../../storage/AdminStore";
import CompanyEdit from "../CompanyEdit";

const NewCompany = () => {
  useEffect(() => {
    adminStore.resetCompany()
  }, [])
  return (
    <CompanyEdit company={adminStore.company} redirect={'/admin/companies'}/>
  )
}

export default observer(NewCompany);